import { AntragHelperService } from '../../antrags-overview/antrag-helper.service';
import { Observable } from 'rxjs';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'statusToI18n',
  standalone: true,
})
export class StatusToI18nPipe implements PipeTransform {
  public antragsHelper: AntragHelperService = inject(AntragHelperService);

  public transform(value: number): Observable<string> {
    return this.antragsHelper.getStateI18nKey(value);
  }
}
